// socketStore.js
/* eslint-disable */
import { defineStore } from 'pinia';
import emitter from '@/helpers/emmiter';
import io from 'socket.io-client';
import { useRouter } from 'vue-router';
import { useCustomerStore } from './customer';
import { useFixtureStore } from './fixture';
import { useLiveSportsStore } from './live_sports';
import { useLiveSportOverview } from './live_sport_overview';
import { useVirtualCourtStore } from './virtual_court';
import { useHistoryBetsStore } from './history_bets';
import { useLiveHomeFixturesStore } from './live_home_fixtures';
import { useAllLiveSportOverview } from './all_live_sport_overview';
import { useSportPopularStore } from './sport_popular';
import { useCompetitionsStore } from './competitions';
import { useFavouritesStore } from './favourites';
import { EditBetSlip } from './edit_betslip';
import { useInitializeStore } from './initialize';
import { useBestlineVideoStore } from './bestline_video';
import { useTimedSportStore } from './timed_sport';
import { useBetBoosterStore } from './bet_booster';

import { MyBets } from './MyBets';
import { BetSlip } from './BetSlip';
import FixtureWorker from '@/workers/fixture.worker.js';

export const useSocketStore = defineStore('socket', {
	state: () => ({
		socket: null,
		locale: 'en',
		joined_channels: {},
		debug: 'arazw xalaros',
		connection_times: 0,
		errors_caught: 0,
		connected: false
	}),
	getters: {
		getSocket() {
			return this.socket;
		},
		showSocketChannels() {
			return this.joined_channels;
		}
	},
	actions: {
		registerListeners() {
			const customerStore = useCustomerStore();
			const fixtureStore = useFixtureStore();
			const liveSportsStore = useLiveSportsStore();
			const liveSportOverviewStore = useLiveSportOverview();
			const historyBetsStore = useHistoryBetsStore();
			const liveHomeFixturesStore = useLiveHomeFixturesStore();
			const sportPopularStore = useSportPopularStore();
			const allLiveSportOverviewStore = useAllLiveSportOverview();
			const competitionsStore = useCompetitionsStore();
			const favouritesStore = useFavouritesStore();
			const betslipStore = BetSlip();
			const editBetslipStore = EditBetSlip();
			const initializeStore = useInitializeStore();
			const bestlineVideoStore = useBestlineVideoStore();
			const virtualCourtStore = useVirtualCourtStore();
			const myBetsStore = MyBets();

			const timedSportStore = useTimedSportStore();
			const betBoosterStore = useBetBoosterStore();
			const fixtureWorker = new FixtureWorker();

			fixtureWorker.onmessage = (event) => {
				const { action, data } = event.data;

				switch(action) {
					case 'liveFixtureBook':
						fixtureStore.setFixture(data);
						fixtureStore.setFixtureLoading(false);
						emitter.emit('liveFixtureBook', data);
						break;
					case 'liveFixtureBookUpdate':
						fixtureStore.setFixture(data);
						break;
					case 'liveFixtureBookNotFound':
						fixtureStore.setFixtureLoading(false);
						emitter.emit('liveFixtureBookNotFound');
						break;
					case 'liveFixtureBookDelete':
						let sport_id = fixtureStore.fixture ? fixtureStore.fixture.sport_id : (data ? data.sport_id : null);
						fixtureStore.emptyFixture(data);
						emitter.emit('liveFixtureBookDelete', sport_id);
						break;
				}
			};

			this.socket.on('competitionFixtures', (data) => {
				competitionsStore.setCompetitionFixtures(data);
				emitter.emit('competitionFixtures', data);
			});

			this.socket.on('competitionFixturesUpdate', (data) => {
				competitionsStore.updateCompetitionFixture(data);
			});

			this.socket.on('competitionFixturesDelete', (data) => {
				competitionsStore.deleteCompetitionFixture(data);
			});

			this.socket.on('esportsLiveSportsOverview', (data) => {
				allLiveSportOverviewStore.setOverview(data);
			});

			this.socket.on('esportsLiveSportsOverviewUpdate', (data) => {
				allLiveSportOverviewStore.updateOverview(data);
			});

			this.socket.on('sportHighlights', (data) => {
				sportPopularStore.setPopularFixtures(data);
			})

			this.socket.on('sportHighlightsUpdate', (data) => {
				sportPopularStore.updatePopularFixtures(data);
			});

			this.socket.on('SportHighlightsFixturePatch', (data) => {
				sportPopularStore.setPopularFixturePatch(data);
			})

			this.socket.on('SportHighlightsFixtureInsert', (data) => {
				sportPopularStore.setPopularFixture(data);
			})

			this.socket.on('SportHighlightsFixtureDelete', (data) => {
				sportPopularStore.deletePopularFixture(data);
			})

			this.socket.on('SportHighlightsFixtureUpdate', (data) => {
				sportPopularStore.updatePopularFixture(data);
			});


			this.socket.on('liveHomeFixtures', (data) => {
				liveHomeFixturesStore.setLiveHomeFixturesSnapshot(data);
			})

			this.socket.on('liveHomeFixturesUpdate', (data) => {
				liveHomeFixturesStore.updateLiveHomeFixtures(data);
			});

			this.socket.on('LiveHomeFixturesInsert', (data) => {
				liveHomeFixturesStore.setLiveHomeFixture(data);
			});

			this.socket.on('LiveHomeFixturesPatch', (data) => {
				liveHomeFixturesStore.setLiveHomeFixturePatch(data);
			});


			this.socket.on('LiveHomeFixturesDelete', (data) => {
				liveHomeFixturesStore.deleteLiveHomeFixture(data);
			});

			this.socket.on('LiveHomeFixturesDelete', (data) => {
				liveHomeFixturesStore.deleteLiveHomeFixture(data);
			});

			this.socket.on('liveSports', (data) => {
				liveSportsStore.setLiveSports(data);
				let first_sport = liveSportsStore.liveSports[0];
				liveSportsStore.setSelectedLiveSportId(first_sport.id);
			});

			this.socket.on('liveSportsUpdate', (data) => {
				liveSportsStore.updateLiveSports(data);
			});

			this.socket.on('liveSportOverview', (data) => {
				liveSportOverviewStore.setOverview(data);
				liveSportOverviewStore.loading = false;
				emitter.emit('liveSportOverview');
			})

			this.socket.on('liveSportOverviewUpdate', (data) => {
				liveSportOverviewStore.updateOverview(data);
			})

			this.socket.on('liveFixtureBook', (data) => {
				fixtureWorker.postMessage({ action: 'liveFixtureBook', data });
			});

			this.socket.on('liveFixtureBookNotFound', () => {
				fixtureWorker.postMessage({ action: 'liveFixtureBookNotFound' });
			});

			this.socket.on('liveFixtureBookUpdate', (data) => {
				fixtureWorker.postMessage({ action: 'liveFixtureBookUpdate', data });
			});

			this.socket.on('liveFixtureBookDelete', (data) => {
				fixtureWorker.postMessage({ action: 'liveFixtureBookDelete', data });
			});

			if (customerStore.isLoggedIn) {
				this.socket.on('myBetsSnapshot', (data) => {
					myBetsStore.setMyBetsSnapshot(data);
					historyBetsStore.setMyBetsSnapshot(data);
				});
			}

			// Fixture Odd Info Socket chanels
			this.socket.on('fixtureOddInfo', (data) => {
				myBetsStore.setFixtureOddInfo(data);
				historyBetsStore.setFixtureOddInfo(data);
			});

			this.socket.on('fixtureOddInfoInsert', (data) => {
				betslipStore.addFixtureOddInfo(data);
				myBetsStore.setFixtureOddInfoInsert(data);
				historyBetsStore.setFixtureOddInfoInsert(data);
				editBetslipStore.addFixtureOddInfo(data);
			});

			this.socket.on('fixtureOddInfoUpdate', (data) => {
				betslipStore.updateFixtureOddInfo(data);
				if (customerStore.isLoggedIn) {
					myBetsStore.setFixtureOddInfoUpdate(data);
					historyBetsStore.setFixtureOddInfoUpdate(data);
					editBetslipStore.updateFixtureOddInfo(data);
				}
			});

			this.socket.on('fixtureOddInfoDelete', (data) => {
				betslipStore.deleteFixtureOddInfo(data);
				if (customerStore.isLoggedIn) {
					myBetsStore.setFixtureOddInfoDelete(data);
					historyBetsStore.setFixtureOddInfoDelete(data);
					editBetslipStore.deleteFixtureOddInfo(data);
				}
			});

			this.socket.on('FixtureOddInfoMarketDelete', (data) => {
				console.log('data', data);
				betslipStore.deleteFixtureOddInfoMarket(data);
				if (customerStore.isLoggedIn) {
					myBetsStore.setFixtureOddInfoMarketDelete(data);
					// historyBetsStore.setFixtureOddInfoMarketDelete(data);
					// editBetslipStore.deleteFixtureOddInfoMarket(data);
				}
			});
			// Fixture Info Socket chanels
			this.socket.on('fixtureInfo', (data) => {
				if (customerStore.isLoggedIn) {
					myBetsStore.setFixtureInfo(data);
				}
			});

			this.socket.on('fixtureInfoUpdate', (data) => {
				if (customerStore.isLoggedIn) {
					myBetsStore.setFixtureInfoUpdate(data);
				}
			});

			this.socket.on('fixtureInfoDelete', (data) => {
				if (customerStore.isLoggedIn) {
					myBetsStore.setFixtureInfoDelete(data);
				}
			});

			this.socket.on('favouriteFixture', (data) => {
				favouritesStore.setFavouriteFixture(data);
				betBoosterStore.setFixture(data);
			});

			this.socket.on('favouriteFixtureUpdate', (data) => {
				favouritesStore.updateFavouriteFixture(data);
				betBoosterStore.updateFixture(data);
			});

			this.socket.on('favouriteFixtureDelete', (data) => {
				favouritesStore.deleteFavouriteFixture(data);
				betBoosterStore.deleteFixture(data);
				timedSportStore.deleteFavouriteFixture(data);
			});

			this.socket.on('productSettingsChanged', (data) => {
				initializeStore.setProductSettings(data);
				emitter.emit('productSettingsChanged');
			});

			this.socket.on('virtualCourtAuth', (data) => {
				virtualCourtStore.setToken(data);
			});

			this.socket.on('streamingEvents', (data) => {
				bestlineVideoStore.setStreamingUrls(data);
			});

			this.socket.on('videoUpdates', (data) => {
				bestlineVideoStore.setVideoEvents(data);
			});

		},

		disconnectSocket() {
			if (this.socket) {
				this.socket.disconnect();
				this.connected = false;
				// this.socket = null;
			}
		},
		initializeSocket(locale) {
			this.socket = io(process.env.VUE_APP_SOCKET_IO_URL + 'sb-' + locale, {
				path: process.env.VUE_APP_SOCKET_IO_PATH,
				transports: ['websocket'],
				reconnection: true,
				reconnectionAttempts: Infinity,
				reconnectionDelay: 1000,
			})

			this.socket.on('connect', () => {
				console.log('Connected:', this.socket.id);
				this.connection_times++;
				this.debug = 'Connected ' + this.connection_times;
				this.connected = true;

				if (this.connection_times > 1) this.joinOldChanels()
			});

			this.socket.on('disconnect', () => {
				this.connected = false;
			});

			if (typeof window !== 'undefined' && typeof document !== 'undefined') {
				document.addEventListener('visibilitychange', () => {
					if (document.visibilityState === 'visible') {
						if (this.socket && !this.socket.connected) {
							console.log('App resumed, socket disconnected. Connecting...');
							this.socket.connect();
						}
					}
				});
			}

			this.registerListeners();
		},
		join(command, params = null) {
			if (params) this.getSocket.emit('join-' + command, params);
			else this.getSocket.emit('join-' + command);

			if (!this.joined_channels[command]) {
				this.joined_channels[command] = {};
			}
			if (typeof params == 'object') {
				this.joined_channels[command][JSON.stringify(params)] = null
			} else {
				this.joined_channels[command][params] = null
			}

		},
		leave(command, params = null) {
			if (params) this.getSocket.emit('leave-' + command, params);
			else this.getSocket.emit('leave-' + command);

			if (this.joined_channels[command]) {
				if (!params) delete this.joined_channels[command];
				else {
					if (typeof params == 'object') {
						delete this.joined_channels[command][JSON.stringify(params)]
					} else {
						delete this.joined_channels[command][params]
					}
				}
			}
		},
		joinOldChanels(state) {
			for (const channel in this.joined_channels) {
				if (this.joined_channels[channel] == null) {
					this.getSocket.emit('join-' + channel);
					continue;
				}

				for (const ipo_channel in this.joined_channels[channel]) {
					if (this.joined_channels[channel][ipo_channel] == null) {
						let parsed_param = ipo_channel;
						try {
							parsed_param = JSON.parse(ipo_channel);
						} catch (e) {
							// If parsing fails (e.g. non-JSON string parameters), keep the original string
							this.errors_caught++;
							this.debug = `SyntaxError caught: ${e.message} for parameter: "${ipo_channel}" (Total: ${this.errors_caught})`;
						}
						this.getSocket.emit('join-' + channel, parsed_param);
					}
				}
			}
		}
	},

});